import styled from "styled-components";

export const DesignationItemHeader = styled.div`
  display: flex;
  justify-content: space-between;

  input {
    width: 33%;
  }

  .col-new-designation-item__wrapper {
    min-width: 220px;
  }

  .btn[data-testid^="designation-item__suggest-new"] {
    max-width: calc(100% - 24px);
  }
`;